import { jsx as o } from "react/jsx-runtime";
import "../../../ActionButton-B77eJAd5.js";
import "styled-components";
import "react";
import "../../../styles/icons/icons.js";
import "../../layout/Stack/Stack.js";
import "../../layout/Box/Box.js";
import "../../../index-CZ8zjHGv.js";
import "../../layout/Center/Center.js";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../layout/Columns/ColumnsContext.js";
import "../../typography/Text/Text.js";
import "../../../context/Text.js";
import "../../../context/Typography.js";
import "../../../hooks/link/index.js";
import "focus-trap-react";
import "@material/material-color-utilities";
import "../../content/Logo/consts.js";
import "react-select";
import "react-select/async";
import l from "../../controls/MultiSelectDropdown/MultiSelectDropdown.js";
import "../../controls/Toggle/CustomCheckbox.js";
import d from "../FieldError/FieldError.js";
import n from "../FieldLabel/FieldLabel.js";
import a from "../FieldLayout/FieldLayout.js";
function H(i) {
  const {
    name: r,
    label: t,
    error: m,
    showError: p = !1,
    size: f = "medium",
    ...e
  } = i;
  return /* @__PURE__ */ o(a, { showError: p, children: {
    label: /* @__PURE__ */ o(n, { htmlFor: r, children: t }),
    field: /* @__PURE__ */ o(
      l,
      {
        id: r,
        inputId: r,
        "aria-labelledby": r,
        name: r,
        ...e
      }
    ),
    error: /* @__PURE__ */ o(d, { children: m })
  } });
}
export {
  H as default
};
